import {MobileBox} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Background/Mobile/Contents/MobileBox';
import {EditorIcons} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/EditorIcons/EditorIcons';
import {useEnvelope} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Envelope/actions/useEnvelope';
import {useLiners} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Envelope/actions/useLiner';
import {useStamp} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Stamp/actions/useStamp';
import {EditorContainer} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Container/Mobile/EditorContainer';
import {Stickers} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Sticker/components/Stickers/Stickers';

export const EnvelopeEditorMobile = ({flipEnvelope}) => {
  const {envelopeIcons, onEnvelopeChange, selectedEnvelope} = useEnvelope();
  const {linerIcons, onLinerChange, selectedLiner} = useLiners();
  const {stampIcons, onStampChange, selectedStamp} = useStamp();

  return (
    <EditorContainer scrolls flipEnvelope={flipEnvelope}>
      <MobileBox title="Colors">
        <EditorIcons
          icons={envelopeIcons}
          onClick={onEnvelopeChange}
          highlight={false}
          selectedIcon={selectedEnvelope?.icon}
          height={40}
          width={40}
          circle
        />
      </MobileBox>
      <MobileBox title="Liner">
        <EditorIcons
          icons={linerIcons}
          onClick={onLinerChange}
          highlight={false}
          selectedIcon={selectedLiner?.icon}
          height={40}
          width={40}
        />
      </MobileBox>
      <MobileBox title="Stamps" showEnvelopeFront>
        <EditorIcons
          icons={stampIcons}
          onClick={onStampChange}
          selectedIcon={selectedStamp?.image}
          height={40}
          width={50}
          className="editor-icons__stamp"
          flipEnvelope={flipEnvelope}
          showEnvelopeFront
        />
      </MobileBox>
      <MobileBox title="Stickers" showEnvelopeFront>
        <Stickers
          className="stamp-editor__content__icons"
          flipEnvelope={flipEnvelope}
          showEnvelopeFront
        />
      </MobileBox>
    </EditorContainer>
  );
};
